import { Modal, Tabs } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import { Shop } from "types/shop";
import { ModalStatus } from "types/modal";
import { InfoTab } from "./TabPane/InfoTab";
import { StaffTab } from "./TabPane/StaffTab";
import { ProductCategoryTab } from "./TabPane/ProductCategoryTab";
import { ProductTab } from "./TabPane/ProductTab";
import { ShopAccountTab } from "./TabPane/ShopAccountTab";
import { ShopOrder } from "./TabPane/ShopOrder";
import { ShopRateTab } from "./TabPane/ShopRateTab";
import { WorkingHourTab } from "./TabPane/WorkingHourTab";
import { ShipFeeTab } from "./TabPane/ShipFeeTab";
import { PartnerTab } from "./TabPane/PartnerTab";

const { TabPane } = Tabs;

export const ShopModal = ({
  isModalVisible,
  status,
  shop,
  onSubmitOk,
  onClose,
}: {
  isModalVisible: boolean;
  status: ModalStatus;
  shop: Partial<Shop>;
  onSubmitOk: () => void;
  onClose: () => void;
}) => {
  const [form] = useForm();
  const [activeKey, setActiveKey] = useState("1");

  useEffect(() => {
    if (status === "create") form.resetFields();
    setActiveKey("1");
  }, [form, isModalVisible, status]);

  return (
    <Modal
      style={{ top: 15 }}
      onCancel={onClose}
      open={isModalVisible}
      title={
        <h1 className="text-xl font-bold text-center">
          {status === "create"
            ? "Thêm mới doanh nghiệp"
            : "Cập nhật doanh nghiệp"}
        </h1>
      }
      footer={null}
      width="100vw"
      className="app-form-modal"
    >
      <div className="app-form-modal__body">
        <section className="app-form-modal__section">
          <Tabs
            className="app-form-modal__tabs"
            defaultActiveKey="1"
            activeKey={activeKey}
            onChange={setActiveKey}
          >
            <TabPane forceRender tab="Thông tin" key="1">
              <InfoTab
                visible={isModalVisible}
                shop={shop}
                status={status}
                onSubmit={onSubmitOk}
                onClose={onClose}
              />
            </TabPane>

            {status === "update" && (
              <>
                {/* <TabPane forceRender tab="Giờ hoạt động" key="7">
                  <WorkingHourTab
                    visible={isModalVisible}
                    shop={shop}
                    status={status}
                    onSubmit={onSubmitOk}
                    onClose={onClose}
                  />
                </TabPane> */}

                {/* <TabPane forceRender tab="Tài khoản" key="2">
                  <ShopAccountTab shopId={shop.id || 0} />
                </TabPane> */}

                <TabPane tab="Danh mục sản phẩm" key="3">
                  <ProductCategoryTab shopId={shop.id || 0} />
                </TabPane>

                <TabPane tab="Sản phẩm" key="4">
                  <ProductTab shopId={shop.id || 0} />
                </TabPane>

                {/* <TabPane tab="Đơn hàng" key="5">
                  <ShopOrder shopId={shop.id} />
                </TabPane> */}

                <TabPane tab="Đánh giá" key="6">
                  <ShopRateTab shopId={shop.id} />
                </TabPane>

                <TabPane tab="Đối tác/Khách hàng" key="7">
                  <PartnerTab shopId={shop.id!} />
                </TabPane>
              </>
            )}
          </Tabs>
        </section>
      </div>
    </Modal>
  );
};
